import Api from './Api';

import axios from "axios";

const api = new Api(axios)

export default api;
